import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import request from './utils/request'
import { formatTime, formatNumber } from './utils/format'
import './styles/global.css'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$http = request
Vue.prototype.$formatTime = formatTime
Vue.prototype.$formatNumber = formatNumber

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// 移动端 table → 卡片：将表头标签注入到 td[data-label]
function injectTableLabels() {
  const tables = document.querySelectorAll('.el-table')
  tables.forEach(table => {
    const headers = Array.from(table.querySelectorAll('.el-table__header-wrapper th.el-table__cell')).map(th => {
      return th.querySelector('.cell')?.textContent?.trim() || ''
    })
    if (!headers.length) return
    table.querySelectorAll('.el-table__body-wrapper tr.el-table__row').forEach(row => {
      row.querySelectorAll('td.el-table__cell').forEach((td, i) => {
        if (headers[i]) td.setAttribute('data-label', headers[i])
      })
    })
  })
}

// 路由切换后注入
router.afterEach(() => setTimeout(injectTableLabels, 100))

// 监听 DOM 变化自动注入（防抖）
let labelTimer = null
const appEl = document.getElementById('app')
if (appEl) {
  const mo = new MutationObserver(() => {
    clearTimeout(labelTimer)
    labelTimer = setTimeout(injectTableLabels, 200)
  })
  mo.observe(appEl, { childList: true, subtree: true })
}
Vue.nextTick(() => injectTableLabels())
